module.exports = "h2 {\n  margin-top: 30px;\n  margin-bottom: 10px;\n  font-size: 25px;\n}\n\nh1 {\n  font-size: 25px;\n}"